import { render, staticRenderFns } from "./AlliancesComponent.vue?vue&type=template&id=347a43f8&scoped=true"
import script from "./AlliancesComponent.vue?vue&type=script&lang=js"
export * from "./AlliancesComponent.vue?vue&type=script&lang=js"
import style0 from "./AlliancesComponent.vue?vue&type=style&index=0&id=347a43f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a43f8",
  null
  
)

export default component.exports